var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscountSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1180_5800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.395 10.5L1.5 5.605V6.605C1.5 6.87 1.605 7.125 1.795 7.31L5.69 11.205C6.08 11.595 6.715 11.595 7.105 11.205L10.21 8.1C10.6 7.71 10.6 7.075 10.21 6.685L6.395 10.5Z",
    fill: "#002CB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69 8.705C5.885 8.9 6.14 9 6.395 9C6.65 9 6.905 8.9 7.1 8.705L10.205 5.6C10.595 5.21 10.595 4.575 10.205 4.185L6.31 0.29C6.125 0.105 5.87 0 5.605 0H2.5C1.95 0 1.5 0.45 1.5 1V4.105C1.5 4.37 1.605 4.625 1.795 4.81L5.69 8.705ZM2.5 1H5.605L9.5 4.895L6.395 8L2.5 4.105V1Z",
    fill: "#002CB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.625 2.75C3.97018 2.75 4.25 2.47018 4.25 2.125C4.25 1.77982 3.97018 1.5 3.625 1.5C3.27982 1.5 3 1.77982 3 2.125C3 2.47018 3.27982 2.75 3.625 2.75Z",
    fill: "#002CB1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1180_5800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountSmall);
export default __webpack_public_path__ + "static/media/DiscountSmall.2259c44de373da191dda47aee5a21e46.svg";
export { ForwardRef as ReactComponent };